const ALERT_PATH_PREFIX = '/audio/dashboard/';

let audio = null;

const getAccountId = () => {
  const match = window.location.pathname.match(/accounts\/(\d+)/);
  return match ? match[1] : null;
};

const playAlert = async () => {
  try {
    if (!audio) {
      audio = new Audio(`${ALERT_PATH_PREFIX}ding.mp3`);
      await audio.load();
    }
    await audio.play();
  } catch (_error) {
    // ignore autoplay restrictions
  }
};

export const notifyInternalMessage = ({ message, roomName, roomId }) => {
  if (!message) return;

  const accountId = getAccountId();
  const senderName = message.sender?.name || 'Team Chat';
  const body = message.content || 'Nova mensagem';
  const title = roomName ? `${senderName} · ${roomName}` : senderName;
  const url = accountId
    ? `/app/accounts/${accountId}/internal/rooms/${roomId}`
    : window.location.pathname;

  playAlert();

  if (!('Notification' in window) || Notification.permission !== 'granted') {
    return;
  }

  const notification = new Notification(title, {
    body,
    tag: `internal-room-${roomId}`,
    icon: '/brand-assets/logo_thumbnail.svg',
  });

  notification.onclick = () => {
    window.focus();
    if (url && window.location.pathname !== url) {
      window.location.href = url;
    }
    notification.close();
  };
};

export default { notifyInternalMessage };
